import axios from '../axios';

const createProject = (formValues) => {
    axios.post(
        `${'projects'}`, formValues
    ).then(
        (res) => {
            console.log(res.data);
        },
        (err) => {
            console.error(err);
        }
    );
    // for (let index = 0; index < formValues.missionId.length; index++) {
    //   const mission = formValues.missionId[index];
    //   mission.projectId=formV
    //   axios.put(
    //     `${MISSION_API_URL}`+"/"+`${mission._id}`,mission
    // ).then(
    //   (res) => {
    //       console.log(res.data);
    //     },
    //     (err) => {
    //       console.error(err);
    //     }
    // );

    // }

};
//fetches last 7 projects
const fetchLastProjects = (setLastProjects) => {
    axios.get(`${'projects'}`, { params: { number: 7 } }).then(
        (res) => {
            console.log(res.data);
            setLastProjects(res.data);

        },
        (err) => {
            console.error('error in getting last projects', err);
        }
    );
};

const fetchProjects = (setProjects) => {
    axios.get(`${'projects'}`).then(
        (res) => {
            console.log(res.data);
            setProjects(res.data);

        },
        (err) => {
            console.error('error in getting  projects', err);
        }
    );

};

export { createProject, fetchLastProjects, fetchProjects };